import React from "react";
import { Card, Divider, List, Row, Col, Empty, Button, Typography, message } from "antd";
import { get_task_dataset_download } from "../../../services/task";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

interface Props {
  evaluation: any[];
  taskDetail: any[];
  isMember?: boolean;
}

const TabEvaluation: React.FC<Props> = ({ evaluation, taskDetail, isMember = false }) => {
  const { t } = useTranslation();

  // Parse dataset from taskDetail
  const getDatasets = () => {
    if (!taskDetail[0]?.dataset) return { public: [], private: [] };
    try {
      const datasetObj = JSON.parse(taskDetail[0].dataset);
      return {
        public: datasetObj?.dataset?.public || [],
        private: datasetObj?.dataset?.private || []
      };
    } catch (e) {
      console.error("Error parsing dataset:", e);
      return { public: [], private: [] };
    }
  };

    const saveCount = async (task_id: string, name: string) => {
    try {
      const data = {
        task_id: task_id,
        name: name,
      };
      const res = await get_task_dataset_download(data);
    } catch (e) {
      console.error(e);
      message.error("Error occurred while updating data.");
    }
  };
  
  const datasets = getDatasets();

  return (
    <>
      {isMember && datasets.public.length > 0 && (
        <Card>
          <p style={{ margin: 10, fontSize: 16, fontWeight: "bold" }}>
            {t("Dataset")}
          </p>
          <Divider />

          {/* Public Datasets Only */}
          <List
            dataSource={datasets.public}
            renderItem={(item: any) => {
              let formattedUrl = "";
              if (item.link?.startsWith("http")) formattedUrl = item.link;
              else if (item.link?.startsWith("www."))
                formattedUrl = `http://${item.link}`;
              else formattedUrl = `${process.env.REACT_APP_API}${item.link}`;

              return (
                <List.Item>
                  <Col span={16}>
                    <p style={{ marginBottom: 0 }}>{item.name}</p>
                    {item.description && (
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        {item.description}
                      </Text>
                    )}
                    {item.samples && (
                      <Text type="secondary" style={{ fontSize: 12, display: "block" }}>
                        {t("Samples")}: {item.samples}
                      </Text>
                    )}
                  </Col>
                  <Col span={8}>
                    <Button
                      type="primary"
                      onClick={() => {
                        saveCount(taskDetail[0]?.task_id, item.name);
                        window.open(formattedUrl, "_blank");
                      }}
                      style={{ backgroundColor: "#1AACAC", color: "#fff" }}
                    >
                      {t("Download")}
                    </Button>
                  </Col>
                </List.Item>
              );
            }}
          />
        </Card>
      )}

      <Card style={{ marginTop: 24 }}>
        <p style={{ margin: 10, fontSize: 16, fontWeight: "bold" }}>
          {t("Evaluation")}
        </p>
        <Divider />

        {taskDetail.length > 0 && (
          <List
            dataSource={evaluation}
            renderItem={(item: any) => {
              if (!item.url) return null;
              let formattedUrl = "";
              if (item.url.startsWith("http")) formattedUrl = item.url;
              else if (item.url.startsWith("www."))
                formattedUrl = `http://${item.url}`;
              else formattedUrl = `${process.env.REACT_APP_API}${item.url}`;

              return (
                <List.Item>
                  <Col span={16}>
                    <p style={{ marginBottom: 0 }}>{item.name}</p>
                  </Col>
                  <Col span={8}>
                    <Button
                      type="primary"
                      onClick={() => window.open(formattedUrl, "_blank")}
                      style={{ backgroundColor: "#1AACAC", color: "#fff" }}
                    >
                      {t("Download")}
                    </Button>
                  </Col>
                </List.Item>
              );
            }}
          />
        )}

        {evaluation.filter((e) => e.url != null).length === 0 && (
          <Row justify="center">
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </Row>
        )}
      </Card>
      <Card style={{ marginTop: 24 }}>
        <p
          style={{
            marginLeft: "10px",
            // marginTop: 30,
            fontSize: 16,
            fontWeight: "bold",
          }}
        >
          {t("Metric")}
        </p>
        <Divider />

        {taskDetail.length > 0 && taskDetail[0]?.metrics ? (
          <List
            dataSource={JSON.parse(taskDetail[0]?.metrics || "[]")}
            renderItem={(item: any) => (
              <List.Item>
                <Row style={{ width: "100%" }}>
                  <Col span={12}>
                    <Text style={{ fontSize: 16 }}>{item.description}</Text>
                  </Col>
                  <Col span={12} style={{ textAlign: "center" }}>
                    <Text style={{ fontSize: 16 }}>
                      {item.default ? t("Used to measure main results") : "-"}
                    </Text>
                  </Col>
                </Row>
              </List.Item>
            )}
          />
        ) : (
          <p style={{ textAlign: "center", color: "gray" }}>
            {t("No benchmark data")}
          </p>
        )}
      </Card>
    </>
  );
};

export default TabEvaluation;
